import React from 'react'
import classNames from 'classnames'
import { EmptyObject } from 'types/helpers'
import { BadgeProps } from '@components/ui/Badge'
import { ButtonLinkProps } from '@components/ui/Button/ButtonLink'
import styles from './styles.module.scss'
import { File } from 'types/contentful/graphQlApi'
import { HeroBannerMedia } from './HeroBannerMedia'
import { HeroBannerTextContent } from './HeroBannerTextContent'

type Align = 'start' | 'center' | 'end'

export type Variant = 'default' | 'full-bleed'

export type Button =
  | Partial<{
      classes: string
      title: string
      text: string
      uri: string
      buttonStyle: ButtonLinkProps['variant']
      type: string
      event: Record<string, string>
    }>
  | EmptyObject

export type Device =
  | {
      title: string
      description: string
      file: File
    }
  | EmptyObject

export type HeroBannerItemProps = {
  badge: BadgeProps
  desktop: Device
  desktopLarge: Device
  classes?: string
  sendEvent: (event: Button['event']) => void
  tablet: Device
  mobile: Device
  mobileGradient: boolean
  backgroundMode: 'bright' | 'dark'
  horizontalMobileDown: Align
  horizontalTabletDown: Align
  horizontalDesktopUp: Align
  verticalMobileDown: Align
  verticalTabletDown: Align
  verticalDesktopUp: Align
  title?: string
  titleSize: 'S' | 'M' | 'L' | 'XL'
  subtitle?: string
  button: Button
  secondaryButton: Button
  imageOnly: boolean
  isFlashBannerVisible: boolean
  whitebackground: boolean
  mobileFillScreen: boolean
  variant: Variant
}

function HeroBannerItem({ ...props }: HeroBannerItemProps) {
  const {
    imageOnly,
    mobileFillScreen,
    variant,
    titleSize,
    isFlashBannerVisible,
    verticalMobileDown,
    verticalTabletDown,
    ...rest
  } = props

  const isButtonOnly = !props.title && !props.subtitle && !!props.button
  const bottomOffSetMobile = verticalMobileDown === 'end'
  const bottomOffSetTablet = verticalTabletDown === 'end'

  const bannerItemClasses = classNames(styles.bannerItem, {
    [styles[`titleSize--${titleSize}`]]: titleSize,
    [styles.bannerItem_squished]: isFlashBannerVisible,
    [styles.bannerItemVerticalMobileDownBottom]:
      bottomOffSetMobile && !isButtonOnly,
    [styles.bannerItemVerticalTabletCenter]: !bottomOffSetTablet,
    [styles.bannerItem__FullBleed]: variant === 'full-bleed'
  })

  return (
    <div
      className={classNames(bannerItemClasses, props.classes, {
        [styles.bannerItem__mobileStacked]: !mobileFillScreen
      })}
    >
      {!imageOnly && <HeroBannerTextContent {...props} />}
      <HeroBannerMedia {...rest} />
    </div>
  )
}

export default HeroBannerItem
